import { toast } from "@birdwatch/ui/toast";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

export function GlobalErrorHandler({
  children,
}: {
  children: React.ReactNode;
}) {
  const queryClient = useQueryClient();
  const toastDisplayed = useRef(false);

  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      if (event.type === "updated" && event.action.type === "error") {
        handleApiError(event.action.error);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleApiError = (error: any) => {
    const statusCode = error?.response?.status || 500;

    if (statusCode === 503 && !toastDisplayed.current) {
      toastDisplayed.current = true;
      toast.warning({
        title: "Service is currently unavailable. Please try again later.",
        onAutoClose: () => {
          toastDisplayed.current = false;
        },
      });
    }
  };

  return children;
}
